import { useState, useCallback } from 'react';

const TOUR_STORAGE_PREFIX = 'wexler-tour-seen-';

export type TourId = 'matters-list' | 'matter-overview' | 'subsets-list' | 'subset-creation';

/**
 * Hook to manage tour visibility with localStorage persistence.
 * Unlike onboarding dialogs, tours can be re-triggered by the user.
 */
export function useTour(tourId: TourId) {
  const storageKey = `${TOUR_STORAGE_PREFIX}${tourId}`;

  const [isOpen, setIsOpen] = useState(false);

  const openTour = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeTour = useCallback(() => {
    setIsOpen(false);
    try {
      localStorage.setItem(storageKey, 'true');
    } catch (error) {
      console.error('Error closing tour:', error);
    }
  }, [storageKey]);

  const hasSeenTour = useCallback(() => {
    try {
      return localStorage.getItem(storageKey) === 'true';
    } catch (error) {
      console.error('Error checking tour status:', error);
      return false;
    }
  }, [storageKey]);

  return {
    isOpen,
    openTour,
    closeTour,
    hasSeenTour,
  };
}
